import React from 'react';
import { shortAddress } from '../../utils/format';
import { PACKAGE_NAMES } from '../../utils/constants';

export const UserCard = ({ userId, wallet, uplineId, highestPackage }) => (
  <div className="user-card">
    <div className="user-card-top">
      <div className="user-avatar-ring">
        <svg viewBox="0 0 68 68" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="ringGrad" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#00e5ff" />
              <stop offset="50%" stopColor="#a855ff" />
              <stop offset="100%" stopColor="#ff2d92" />
            </linearGradient>
          </defs>
          <circle cx="34" cy="34" r="31" fill="none" stroke="url(#ringGrad)" strokeWidth="2" strokeDasharray="6 4" />
        </svg>
        <div className="inner-avatar">👤</div>
        <div className="status-dot" />
      </div>
      <div className="user-card-info">
        <div className="user-card-id">User #{userId}</div>
        <div className="user-card-wallet">{shortAddress(wallet, 6)}</div>
      </div>
    </div>

    <div className="user-card-badges">
      {uplineId != null && (
        <span className="user-badge">
          <span className="icon">🔗</span>
          Upline #{uplineId}
        </span>
      )}
      {highestPackage != null && (
        <span className="user-badge gold">
          <span className="icon">👑</span>
          {PACKAGE_NAMES[highestPackage] || `Package ${highestPackage}`}
        </span>
      )}
    </div>
  </div>
);
